import React, { useState } from "react";
import { Link } from "react-router-dom";
import Utils from "../../utility";
import ClickOutside from "../../common/components/clickOutside";
import Dropdown from "../../common/components/dropdown";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const Report = ({
  setDate,
  setSelectTime,
  setSelectProcessedTime,
  selectTime,
  setProcessedDate,
  date,
  selectProcessedTime,
  processedDate,
  report,
  setFeebackDate,
  feedbackDate,
  setSelectFeedbackTime,
  selectFeedbackTime,
  setSelectedVersion,
  selectedVersion,
  loading
}) => {
  const [open, setOpen] = useState(false);
  const [openProcessed, setOpenProcessed] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);
  //   const navigate = useNavigate();
  const [range, setRange] = useState({
    startDate: null,
    endDate: new Date(""),
    key: "date"
  });

  const [rangeProcessed, setRangeProcessed] = useState({
    startDate: null,
    endDate: new Date(""),
    key: "selection"
  });

  const [feedbackProcessed, setFeedbackProcessed] = useState({
    startDate: null,
    endDate: new Date(""),
    key: "feedback"
  });

  const handleDateSelect = (ranges) => {
    const { startDate, endDate } = ranges.date;

    const formattedStartDate = Utils.formatDateYear(startDate);
    const formattedEndDate = Utils.formatDateYear(endDate);

    setRange({
      ...range,
      startDate: startDate,
      endDate: endDate
    });

    setDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
  };

  const handleSelect = (value) => {
    setSelectTime(value);
    if (value === "Custom") {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const handleSelectProcessed = (value) => {
    setSelectProcessedTime(value);
    if (value === "Custom") {
      setOpenProcessed(true);
    } else {
      setOpenProcessed(false);
    }
  };

  const handleSelectFeedback = (value) => {
    setSelectFeedbackTime(value);
    if (value === "Custom") {
      setOpenFeedback(true);
    } else {
      setOpenFeedback(false);
    }
  };

  const handleClearFilters = () => {
    setSelectTime("All");

    setRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "date"
    });
    setSelectProcessedTime("Last 14 days");
    setSelectFeedbackTime("All");
    setSelectedVersion("Latest");
  };

  const handleDateSelectProcessed = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    const formattedStartDate = Utils.formatDate(startDate);
    const formattedEndDate = Utils.formatDate(endDate);

    setRangeProcessed({
      ...rangeProcessed,
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate
    });

    setProcessedDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
  };

  const handleFeedbackProcessed = (ranges) => {
    const { startDate, endDate } = ranges.feedback;

    const formattedStartDate = Utils.formatDate(startDate);
    const formattedEndDate = Utils.formatDate(endDate);

    setFeedbackProcessed({
      ...feedbackProcessed,
      startDate: ranges.feedback.startDate,
      endDate: ranges.feedback.endDate
    });

    setFeebackDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
  };

  //   const commercial = report?.commercialUsage?.find(
  //     (element) => element.questionText === "Is used commercially?"
  //   );

  //   const correct = commercial?.feedbacksCount?.CORRECT || 0;
  //   const incorrectAI = commercial?.feedbacksCount?.INCORRECT_AI_RESPONSE || 0;
  //   const incorrectData = commercial?.feedbacksCount?.INCORRECT_DATA_IMAGE || 0;
  //   const totalIncorrect = incorrectAI + incorrectData;
  //   const total = correct + totalIncorrect;

  //   const commercialAccuracy =
  //     total > 0 ? `${((correct / total) * 100)?.toFixed(2)}%` : "NA";

  const handleRedirect = (url, isFeedbackDateRequired = true) => {
    let newUrl = `${url}&versionScope=${selectedVersion}`;

    // Handle non-custom time filters
    if (selectProcessedTime && selectProcessedTime !== "Custom") {
      newUrl += `&processedTime=${selectProcessedTime}`;
    }

    if (selectTime && selectTime !== "Custom") {
      newUrl += `&selectTime=${selectTime}`;
    }

    if (
      selectFeedbackTime &&
      selectFeedbackTime !== "Custom" &&
      isFeedbackDateRequired
    ) {
      newUrl += `&feedbackTime=${selectFeedbackTime}`;
    }

    // Handle custom date ranges
    if (selectTime === "Custom" && date?.startDate && date?.endDate) {
      newUrl += `&fromDate=${date.startDate}&toDate=${date.endDate}&selectTime=Custom`;
    }

    if (
      selectProcessedTime === "Custom" &&
      processedDate?.startDate &&
      processedDate?.endDate
    ) {
      newUrl += `&processedOnFrom=${processedDate.startDate}&processedOnTo=${processedDate.endDate}&processedTime=Custom`;
    }

    if (
      selectFeedbackTime === "Custom" &&
      feedbackDate?.startDate &&
      feedbackDate?.endDate &&
      isFeedbackDateRequired
    ) {
      newUrl += `&feedbackFromDate=${feedbackDate.startDate}&feedbackToDate=${feedbackDate.endDate}&feedbackTime=Custom`;
    }

    return newUrl;
  };

  return (
    <div>
      {" "}
      <div className="flex gap-3">
        <div className="flex items-center gap-2 pt-2">
          <span className="font-InterRegular text-ft20-28">Total Claims:</span>
          <span className="font-InterSemiBold text-ft25-30">
            {report?.totalClaims}
          </span>
        </div>
        <div className="flex gap-2 pl-5">
          <ClickOutside isOpen={open} onClickOutside={() => setOpen(false)}>
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Date"}
                value={selectTime}
                list={["All", "Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleSelect}
                setOpenCalendar={setOpen}
                startDate={date?.startDate}
                endDate={date?.endDate}
              />
              {open && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[range]}
                    onChange={handleDateSelect}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>
          <ClickOutside
            isOpen={openProcessed}
            onClickOutside={() => setOpenProcessed(false)}
          >
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Processed"}
                value={selectProcessedTime}
                list={["All", "Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleSelectProcessed}
                setOpenCalendar={setOpenProcessed}
                startDate={processedDate?.startDate}
                endDate={processedDate?.endDate}
              />
              {openProcessed && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[rangeProcessed]}
                    onChange={handleDateSelectProcessed}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>
          <ClickOutside
            isOpen={openFeedback}
            onClickOutside={() => setOpenFeedback(false)}
          >
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Feedback Date"}
                value={selectFeedbackTime}
                list={["All", "Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleSelectFeedback}
                setOpenCalendar={setOpenFeedback}
                startDate={feedbackDate?.startDate}
                endDate={feedbackDate?.endDate}
              />
              {openFeedback && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[feedbackProcessed]}
                    onChange={handleFeedbackProcessed}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>
          <Dropdown
            width={"min-w-31"}
            text={"Version Scope"}
            value={selectedVersion}
            list={["All", "Latest"]}
            handleSelect={setSelectedVersion}
            // setCurrentPage={setCurrentPage}
          />
        </div>
        <div
          className="flex cursor-pointer items-center gap-1"
          onClick={handleClearFilters}
        >
          <span className="font-InterRegular text-ft14-17 text-blue-10">
            Clear
          </span>
          <img src="/images/clear.svg" alt="" />
        </div>
      </div>
      {loading ? (
        <div className="flex h-75vh items-center justify-center">
          <div className="loader "></div>
        </div>
      ) : (
        <div className="mt-5 grid w-full grid-cols-3 gap-5 xl:grid-cols-5">
          <Link
            to={handleRedirect("/claim-list?result=Open&report=true", false)}
          >
            <div className="flex h-24 w-full flex-col gap-3 rounded-lg border border-grey-10 bg-grey-10 bg-opacity-20 p-3">
              <span className="font-InterRegular text-ft16-24">Open</span>
              <span className="font-InterRegular text-ft24-32 text-blue-30 hover:underline">
                {report?.Open}
              </span>
            </div>
          </Link>
          <Link
            to={handleRedirect(
              "/claim-list?result=InProgress&report=true",
              false
            )}
          >
            <div className="flex h-24 w-full flex-col gap-3 rounded-lg border border-grey-10 bg-grey-10 bg-opacity-20 p-3">
              <span className="font-InterRegular text-ft16-24">InProgress</span>
              <span className="font-InterRegular text-ft24-32 text-blue-30 hover:underline">
                {report?.InProgress}
              </span>
            </div>
          </Link>
          <Link
            to={handleRedirect("/claim-list?result=Failed&report=true", false)}
          >
            <div className="flex h-24 w-full flex-col gap-3 rounded-lg border border-grey-10 bg-grey-10 bg-opacity-20 p-3">
              <span className="font-InterRegular text-ft16-24">Failed</span>
              <span className="font-InterRegular text-ft24-32 text-blue-30 hover:underline">
                {report?.Failed}
              </span>
            </div>
          </Link>
          <Link
            to={handleRedirect("/claim-list?result=Success&report=true", false)}
          >
            <div className="flex h-24 w-full flex-col gap-3 rounded-lg border border-grey-10 bg-grey-10 bg-opacity-20 p-3">
              <span className="font-InterRegular text-ft16-24">Success</span>
              <span className="font-InterRegular text-ft24-32 text-blue-30 hover:underline">
                {report?.Success}
              </span>
            </div>
          </Link>

          {/* <div className="p- col-span-3 border border-grey-10 bg-grey-10 bg-opacity-20 xl:col-span-5">
          <table className="w-full">
            <thead>
              <tr className="sticky top-0  z-10 w-full bg-white font-InterBold text-ft10-18.15 text-black-10">
                <td className="py-2 pl-2.5">Claim Processing Status</td>
                <td>Count</td>
              </tr>
            </thead>
            <tbody>
              <tr className="cursor-pointer border-t border-grey-30">
                <td className="w-15per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                  Images Processed Within SLA
                </td>
                <td className="w-10per pl-2 font-InterRegular text-ft15-18 ">
                  <Link
                    className="text-blue-30 hover:underline"
                    to={handleRedirect("/claim-list?slaCompliance=slaMet")}
                  >
                    {report?.slaMet}
                  </Link>
                </td>
              </tr>
              <tr className="cursor-pointer border-t border-grey-30">
                <td className="w-15per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                  Images Processed Missed SLA
                </td>
                <td className="w-10per pl-2 font-InterRegular text-ft15-18 ">
                  <Link
                    className="text-blue-30 hover:underline"
                    to={handleRedirect("/claim-list?slaCompliance=slaNotMet")}
                  >
                    {report?.slaNotMet}
                  </Link>
                </td>
              </tr>
              <tr className="cursor-pointer border-t border-grey-30">
                <td className="w-15per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                  Images Processing Pending (SLA)
                </td>
                <td className="w-10per pl-2 font-InterRegular text-ft15-18 ">
                  <Link
                    className="text-blue-30 hover:underline"
                    to={handleRedirect("/claim-list?slaCompliance=slaOngoing")}
                  >
                    {report?.slaOngoing}
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div> */}

          {report?.commercialUsage?.length > 0 && (
            <div className="p- col-span-3 border border-grey-10 bg-grey-10 bg-opacity-20 xl:col-span-5">
              <table className="w-full">
                <thead>
                  <tr className="sticky top-0  z-10 w-full bg-white font-InterBold text-ft10-18.15 text-black-10">
                    <td className="py-2 pl-2.5">Commercial Usage</td>
                    <td>Correct</td>
                    <td>Correct (As Per Input & Rules)</td>
                    <td>Incorrect Data/Image</td>
                    <td>Incorrect AI Response</td>
                    <td>AI Accuracy</td>
                  </tr>
                </thead>
                <tbody>
                  {report?.commercialUsage?.map((item, idx) => {
                    return (
                      <tr
                        key={idx}
                        className="cursor-pointer border-t border-grey-30"
                      >
                        <td className="w-15per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                          {Utils.camelToTitleCase(item?.questionText)}
                        </td>
                        <td className="w-10per pl-2 font-InterRegular text-ft15-18 ">
                          <Link
                            className="text-blue-30 hover:underline"
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=CORRECT&feedbackType=commercialUsage`
                            )}
                          >
                            {item?.feedbacksCount?.CORRECT || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=GEN_AI_CORRECT_INSUFFICIENT_INPUTS&feedbackType=commercialUsage`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount
                              ?.GEN_AI_CORRECT_INSUFFICIENT_INPUTS || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_DATA_IMAGE&feedbackType=commercialUsage`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount?.INCORRECT_DATA_IMAGE || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_AI_RESPONSE&feedbackType=commercialUsage`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount?.INCORRECT_AI_RESPONSE || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          {item.accuracyPercentage > 0
                            ? `${item.accuracyPercentage}%`
                            : 0}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {report?.vinComparison?.length > 0 && (
            <div className="p- col-span-3 border border-grey-10 bg-grey-10 bg-opacity-20 xl:col-span-5">
              <table className="w-full">
                <thead>
                  <tr className="sticky top-0  z-10 w-full bg-white font-InterBold text-ft10-18.15 text-black-10">
                    <td className="py-2 pl-2.5">VIN Comparison</td>
                    <td>Correct</td>
                    <td>Correct (As Per Input & Rules)</td>
                    <td>Incorrect Data/Image</td>
                    <td>Incorrect AI Response</td>
                    <td>AI Accuracy</td>
                  </tr>
                </thead>
                <tbody>
                  {report?.vinComparison?.map((item, idx) => {
                    return (
                      <tr
                        key={idx}
                        className="cursor-pointer border-t border-grey-30"
                      >
                        <td className="w-15per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                          {Utils.camelToTitleCase(item?.questionText)}
                        </td>
                        <td className="w-10per pl-2 font-InterRegular text-ft15-18 ">
                          <Link
                            className="text-blue-30 hover:underline"
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=CORRECT&feedbackType=vinComparison`
                            )}
                          >
                            {item?.feedbacksCount?.CORRECT || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=GEN_AI_CORRECT_INSUFFICIENT_INPUTS&feedbackType=vinComparison`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount
                              ?.GEN_AI_CORRECT_INSUFFICIENT_INPUTS || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_DATA_IMAGE&feedbackType=vinComparison`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount?.INCORRECT_DATA_IMAGE || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_AI_RESPONSE&feedbackType=vinComparison`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount?.INCORRECT_AI_RESPONSE || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          {item.accuracyPercentage > 0
                            ? `${item.accuracyPercentage}%`
                            : 0}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {report?.damageResults?.length > 0 && (
            <div className="p- col-span-3 border border-grey-10 bg-grey-10 bg-opacity-20 xl:col-span-5">
              <table className="w-full">
                <thead>
                  <tr className="sticky top-0  z-10 w-full bg-white font-InterBold text-ft10-18.15 text-black-10">
                    <td className="py-2 pl-2.5">Damage Results</td>
                    <td>Correct</td>
                    <td>Correct (As Per Input & Rules)</td>
                    <td>Incorrect Data/Image</td>
                    <td>Incorrect AI Response</td>
                    <td>AI Accuracy</td>
                  </tr>
                </thead>
                <tbody>
                  {report?.damageResults?.map((item, idx) => {
                    return (
                      <tr
                        key={idx}
                        className="cursor-pointer border-t border-grey-30"
                      >
                        <td className="w-15per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                          {Utils.camelToTitleCase(item?.questionText)}
                        </td>
                        <td className="w-10per pl-2 font-InterRegular text-ft15-18 ">
                          <Link
                            className="text-blue-30 hover:underline"
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=CORRECT&feedbackType=damageResults`
                            )}
                          >
                            {item?.feedbacksCount?.CORRECT || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=GEN_AI_CORRECT_INSUFFICIENT_INPUTS&feedbackType=damageResults`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount
                              ?.GEN_AI_CORRECT_INSUFFICIENT_INPUTS || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_DATA_IMAGE&feedbackType=damageResults`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount?.INCORRECT_DATA_IMAGE || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_AI_RESPONSE&feedbackType=damageResults`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount?.INCORRECT_AI_RESPONSE || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          {item.accuracyPercentage > 0
                            ? `${item.accuracyPercentage}%`
                            : 0}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {/* {report?.mandatoryChecks?.length > 0 && (
          <div className="p- col-span-3 border border-grey-10 bg-grey-10 bg-opacity-20 xl:col-span-5">
            <table className="w-full">
              <thead>
                <tr className="sticky top-0  z-10 w-full bg-white font-InterBold text-ft10-18.15 text-black-10">
                  <td className="py-2 pl-2.5">Same Tire</td>
                  <td>Correct</td>
                  <td> Incorrect Data/Image</td>
                  <td>Incorrect AI Response</td>
                  <td>AI Accuracy</td>
                </tr>
              </thead>
              <tbody>
                {report?.sameTire?.map((item, idx) => {
                  return (
                    <tr
                      key={idx}
                      className="cursor-pointer border-t border-grey-30"
                    >
                      <td className="w-15per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                        {Utils.camelToTitleCase(item?.questionText)}
                      </td>
                      <td className="w-10per pl-2 font-InterRegular text-ft15-18 ">
                        <Link
                          className="text-blue-30 hover:underline"
                          to={handleRedirect(
                            `/claim-list?questionText=${item?.questionText}&reportFeedback=CORRECT&feedbackType=sameTire`
                          )}
                        >
                          {item?.feedbacksCount?.CORRECT || 0}
                        </Link>
                      </td>
                      <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                        <Link
                          to={handleRedirect(
                            `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_DATA_IMAGE&feedbackType=sameTire`
                          )}
                          className="text-blue-30 hover:underline"
                        >
                          {item?.feedbacksCount?.INCORRECT_DATA_IMAGE || 0}
                        </Link>
                      </td>
                      <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                        <Link
                          to={handleRedirect(
                            `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_AI_RESPONSE&feedbackType=sameTire`
                          )}
                          className="text-blue-30 hover:underline"
                        >
                          {item?.feedbacksCount?.INCORRECT_AI_RESPONSE || 0}
                        </Link>
                      </td>
                      <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                        {item.accuracyPercentage > 0
                          ? `${item.accuracyPercentage}%`
                          : 0}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )} */}
          {report?.mandatoryChecks?.length > 0 && (
            <div className="p- col-span-3 border border-grey-10 bg-grey-10 bg-opacity-20 xl:col-span-5">
              <table className="w-full">
                <thead>
                  <tr className="sticky top-0  z-10 w-full bg-white font-InterBold text-ft10-18.15 text-black-10">
                    <td className="py-2 pl-2.5">Mandatory Checks</td>
                    <td>Correct</td>
                    <td>Correct (As Per Input & Rules)</td>
                    <td>Incorrect Data/Image</td>
                    <td>Incorrect AI Response</td>
                    <td>AI Accuracy</td>
                  </tr>
                </thead>
                <tbody>
                  {report?.mandatoryChecks?.map((item, idx) => {
                    return (
                      <tr
                        key={idx}
                        className="cursor-pointer border-t border-grey-30"
                      >
                        <td className="w-15per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                          {Utils.camelToTitleCase(item?.questionText)}
                        </td>
                        <td className="w-10per pl-2 font-InterRegular text-ft15-18 ">
                          <Link
                            className="text-blue-30 hover:underline"
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=CORRECT&feedbackType=mandatoryChecks`
                            )}
                          >
                            {item?.feedbacksCount?.CORRECT || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=GEN_AI_CORRECT_INSUFFICIENT_INPUTS&feedbackType=mandatoryChecks`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount
                              ?.GEN_AI_CORRECT_INSUFFICIENT_INPUTS || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_DATA_IMAGE&feedbackType=mandatoryChecks`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount?.INCORRECT_DATA_IMAGE || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_AI_RESPONSE&feedbackType=mandatoryChecks`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount?.INCORRECT_AI_RESPONSE || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          {item.accuracyPercentage > 0
                            ? `${item.accuracyPercentage}%`
                            : 0}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {report?.additionalQuestions?.length > 0 && (
            <div className="p- col-span-3 border border-grey-10 bg-grey-10 bg-opacity-20 xl:col-span-5">
              <table className="w-full">
                <thead>
                  <tr className="sticky top-0  z-10 w-full bg-white font-InterBold text-ft10-18.15 text-black-10">
                    <td className="py-2 pl-2.5">Additional Questions</td>
                    <td>Correct</td>
                    <td>Correct (As Per Input & Rules)</td>
                    <td>Incorrect Data/Image</td>
                    <td>Incorrect AI Response</td>
                    <td>AI Accuracy</td>
                  </tr>
                </thead>
                <tbody>
                  {report?.additionalQuestions?.map((item, idx) => {
                    return (
                      <tr
                        key={idx}
                        className="cursor-pointer border-t border-grey-30"
                      >
                        <td className="w-15per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                          {Utils.camelToTitleCase(item?.questionText)}
                        </td>
                        <td className="w-10per pl-2 font-InterRegular text-ft15-18 ">
                          <Link
                            className="text-blue-30 hover:underline"
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=CORRECT&feedbackType=additionalQuestions`
                            )}
                          >
                            {item?.feedbacksCount?.CORRECT || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=GEN_AI_CORRECT_INSUFFICIENT_INPUTS&feedbackType=additionalQuestions`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount
                              ?.GEN_AI_CORRECT_INSUFFICIENT_INPUTS || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_DATA_IMAGE&feedbackType=additionalQuestions`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount?.INCORRECT_DATA_IMAGE || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          <Link
                            to={handleRedirect(
                              `/claim-list?questionText=${item?.questionText}&reportFeedback=INCORRECT_AI_RESPONSE&feedbackType=additionalQuestions`
                            )}
                            className="text-blue-30 hover:underline"
                          >
                            {item?.feedbacksCount?.INCORRECT_AI_RESPONSE || 0}
                          </Link>
                        </td>
                        <td className="w-15per pl-2 font-InterRegular text-ft15-18 text-black-10">
                          {item.accuracyPercentage > 0
                            ? `${item.accuracyPercentage}%`
                            : 0}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Report;
